import { DeviceType } from '@nab/x-types';

export function isMobile(): boolean {
    const toMatch = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];

    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
}
export function isMobileWebview(): boolean {
    const webviewMatchers = /webview|wv|ip((?!.*Safari)|(?=.*like Safari))/i;
    return webviewMatchers.test(navigator.userAgent);
}

export function getBrowserType(): DeviceType {
    if (isMobileWebview()) {
        return 'NATIVE_APPLICATION' as DeviceType;
    }
    if (isMobile()) {
        return 'MOBILE_BROWSER' as DeviceType;
    }
    return 'DESKTOP_BROWSER' as DeviceType;
}
